import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const alertVariants = cva(
  "relative w-full p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground rounded-md isolate box-border border-[0.5px] border-transparent before:inset-0 before:border-t-[0.5px] before:border-white/20 before:h-full before:w-full before:absolute before:rounded-[inherit] before:bg-gradient-to-b before:from-white/[0.03] before:to-black/[0.03] before:pointer-events-none dark:before:top-[-0.5px] dark:before:w-[calc(100%+1px)] dark:before:start-[-0.5px] dark:before:end-[-0.5px] after:absolute after:inset-[-0.5px] after:rounded-[inherit] after:pointer-events-none after:-z-10 after:border-[0.5px] after:border-black/20 dark:after:border-white/10 after:shadow-sm",
  {
    variants: {
      variant: {
        default: "bg-secondary text-foreground",
        destructive:
          "bg-destructive/10 text-destructive [&>svg]:text-destructive",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
))
Alert.displayName = "Alert"

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn("mb-1 font-medium leading-none tracking-tight", className)}
    {...props}
  />
))
AlertTitle.displayName = "AlertTitle"

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm [&_p]:leading-relaxed", className)}
    {...props}
  />
))
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertTitle, AlertDescription }
